import { Button, Flex, Heading, Image, Text, VStack } from "@chakra-ui/react"

import leaveIcon from "#/assets/leave.svg"

import DepositModalDivider from "../Deposit/DepositModal/DepositModalDivider"

export type ModalLeaveProps = {
  header: string
  leaveModalText: string
  stayText: string
  onClose: () => void
  backToProcessTrigger: () => void
}

export default function ModalLeave({
  header,
  leaveModalText,
  stayText,
  onClose,
  backToProcessTrigger,
}: ModalLeaveProps) {
  return (
    <VStack gap={0}>
      <Image src={leaveIcon} mb={8} />
      <Heading variant="h2" color="primary.red.100">
        {header}
      </Heading>
      <VStack gap={0} px={14} w="100%">
        <DepositModalDivider />
        <Text
          variant="body"
          fontWeight={500}
          fontFamily="riforma.medium"
          textAlign="center"
        >
          Don&apos;t leave the page if you started a transaction <br />
          from your wallet to the provided address.
        </Text>
        <DepositModalDivider />
      </VStack>
      <Flex w="100%" justifyContent="space-between" gap={8}>
        <Button
          variant="primary"
          size="large"
          fontSize="20px"
          lineHeight="24px"
          onClick={backToProcessTrigger}
        >
          {stayText}
        </Button>
        <Button
          variant="secondary"
          size="large"
          fontSize="20px"
          lineHeight="24px"
          onClick={onClose}
        >
          {leaveModalText}
        </Button>
      </Flex>
    </VStack>
  )
}
